import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useApp } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';

const WrongAnswerDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const { wrongAnswers, isLoadingWrongAnswers, setSelectedSubject, setSnackbar, setSelectedTerm, terms } = useApp();

  const handleTermClick = (wrongAnswer) => {
    // 해당 용어 찾기
    const term = terms?.find(t => t.term === wrongAnswer.term && t.subject === wrongAnswer.subject);
    
    if (term) {
      setSelectedTerm(term);
      setSelectedSubject(term.subject);
      onClose();
      navigate('/');
      setSnackbar({
        open: true,
        message: `${term.subject} 과목의 "${term.term}" 용어를 학습합니다.`,
        severity: 'info'
      });
    } else {
      setSnackbar({
        open: true,
        message: '해당 용어를 찾을 수 없습니다.',
        severity: 'error'
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 2 },
          bgcolor: 'background.paper'
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" component="div" fontWeight={600}>
          오답 노트
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: 'text.secondary',
            '&:hover': {
              color: 'text.primary',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {isLoadingWrongAnswers ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <Typography>로딩 중...</Typography>
          </Box>
        ) : wrongAnswers && wrongAnswers.length > 0 ? (
          <Box>
            {wrongAnswers.map((wrongAnswer, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                  p: 2,
                  borderRadius: 1,
                  bgcolor: 'background.default',
                  border: '1px solid',
                  borderColor: 'divider',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    borderColor: 'primary.main',
                  }
                }}
                onClick={() => handleTermClick(wrongAnswer)}
              >
                <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                  {wrongAnswer.term}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  과목: {wrongAnswer.subject}
                </Typography>
                <Typography variant="body2" color="error" gutterBottom>
                  틀린 답변: {wrongAnswer.wrong_answer}
                </Typography>
                <Typography variant="body2" color="success.main">
                  정답: {wrongAnswer.definition}
                </Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <Typography>아직 오답이 없습니다.</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WrongAnswerDialog; 